// extracted by mini-css-extract-plugin
export var form = "NewsletterForm-module--form--66a71";
export var root = "NewsletterForm-module--root--e7a77";